<template>
  <div id="app" class="app">
    <selectCompetition v-show="selectCompetitionModal"></selectCompetition>
    <perfectCompanyInfo v-show="perfectCompanyInfoModal"></perfectCompanyInfo>
    <headerView ref="headerView" v-if="!hideHead" :loged="loged"></headerView>
    <router-view/>
  </div>
</template>

<script>
import headerView from '@/components/public-block/headerView.vue'
import selectCompetition from '@/components/modal/select-competition.vue'
import perfectCompanyInfo from '@/components/modal/perfect-company-info.vue'

export default {
  components: {
    headerView,
    selectCompetition,
    perfectCompanyInfo
  },
  data () {
    return {
      hideHead: false,
      headerType: 0,
    }
  },
  computed: {
    loged: function(){
      let loged = this.$store.state.userInfo?true:false;
      return loged;
    },
    selectCompetitionModal: function(){
      return this.$store.state.competitionListModal
    },
    perfectCompanyInfoModal: function(){
      return this.$store.state.perfectCompanyInfoModal
    }
  },
  watch: {
    $route(){
      this.$store.commit("setCompetitionListModal", false);
      let hideHead = this.$route.meta.hideHead;
      this.$set(this, "hideHead", hideHead);
      
      if(!this.$store.state.userInfo && this.$route.meta.login){
        if(this.$route.meta.en){
          this.$router.push({
            path: "/en/login"
          })
        }else{
          this.$router.push({
            path: "/login"
          })
        }
      }
    }
  },
  created () {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("language");
    this.setUserInfo();
  },
  methods: {
    setUserInfo(){
      let userInfo = localStorage.getItem("n_userInfo");
      let language = localStorage.getItem("n_language")?localStorage.getItem("n_language"):"cn";
      this.$store.commit("setLanguage", language);

      let loginPath = language==="cn"?"/login":"en/login"
      // 判断过期时间
      let LT = localStorage.getItem("LT");
      // 604800000
      let currentTime = Date.now();
      if(!(LT && currentTime<LT) && this.$route.meta.login){
        this.toLogin(loginPath);
        return;
      }
      // 判断、设置用户信息
      try{
        userInfo = JSON.parse(userInfo);
        if(userInfo){
          this.$store.commit("setUserInfo", userInfo);
        }else{
          if(this.$route.meta.login){
            this.toLogin(loginPath)
          }
        }
      }catch(err){
        this.toLogin(loginPath)
      }
    },
    toLogin(loginPath){
      this.$router.push({
        path: loginPath
      })
      localStorage.removeItem("n_userInfo");
    }
  }
}
</script>

<style lang="scss">
.tip{
  font-size: 12px;
}
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color: #2c3e50;
  position: relative;
  font-size: 14px;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.input{
  height: 36px;
  border: none;
  text-align: left;
  padding: 0 10px;
  width: 230px;
  border: 1px solid #BABDC2;
  border-radius: 4px;
  input{
    color: #BABDC2;
    width: 100%;
    height: 100%;
    border: none;
  }
}
.input.search{
  padding-right: 30px;
  position: relative;
  &::after{
    position: absolute;
    content: " ";
    display: block;
    width: 20px;
    height: 20px;
    background-color: #42b983;
    top: 0;
    bottom: 0;
    right: 5px;
    margin: auto;
  }
}
</style>
